/**
 * 外框页（入口页）
 * 包括头部（header）、底部（footer），以及主体（main-content）的切换
 * 分为电脑版和手机版两种布局
 * 跨系统共通（教科研、基础数据等系统）
 * 除data中部分字段（“本页为跨系统共通，仅此部分有区别”）外，其它代码不应当随意修改
 */
<template>
<!-- 注：隐藏头部属性在路由全局守卫中设置 -->
<div class="frame">

  <template>
    <!-- ------------------- 头部区域 ------------------- -->

    <header class="header" :style="{'background-color': '#545c64'}">
      <div class="global-auto-width">
        <!-- 图标+标题 -->
        <div class="system-title">
          <span>{{systemName}}</span>
        </div>
        <!-- 导航 -->
        <div class="menu">
        <el-menu mode="horizontal" router unique-opened background-color="#545c64">
          <template v-for="(meun, index) in menus">
          <el-menu-item v-if="meun.children.length == 0" :index="meun.menuUrl">
            <template>
              <i :class="meun.icon" style="color:#fff"></i>&nbsp;&nbsp;
              <span style="color:#fff">{{meun.menuName}}</span>
            </template>
          </el-menu-item>
          <el-submenu v-else-if="meun.children.length > 0" :index="meun.menuRoot">
            <template slot="title">
              <i :class="meun.icon" style="color:#fff"></i>&nbsp;&nbsp;
                  <span style="color:#fff">{{meun.menuName}}</span>
            </template>
            <el-menu-item v-for="(subMeun, index) in meun.children" :key="index" :index="subMeun.menuUrl">
              <template slot="title">
                <i :class="subMeun.icon" style="color:#fff"></i>
                    <span style="color:#fff">{{subMeun.menuName}}</span>
              </template>
            </el-menu-item>
			  </el-submenu>
		  </template>
		</el-menu>
		</div>
        <!-- 右侧按钮 -->
        <div class="global-pull-right" style="margin-top:10px">
          <!-- 用户 -->
          <el-popover v-model="show.userPopover" popper-class="frame-popover" placement="bottom-end" trigger="click">
          <div style="min-width: 200px;">
            <div class="user-item _name">
              <span>{{user.name}}</span>
            </div>
            <div class="user-item" v-for="(organGroup, index) in user.organGroups" :key="index">
              <span>{{organGroup.name}}</span>
            </div>
            <div class="user-item" v-if="!$baize.isEmpty(user.idNumber)">
              <label><i class="fa fa-id-card-o"></i></label><span>{{user.idNumber}}</span>
            </div>
            <div class="user-item" v-if="!$baize.isEmpty(user.tel)">
              <label><i class="fa fa-phone"></i></label><span>{{user.tel}}</span>
            </div>
            <div class="user-item" v-if="!$baize.isEmpty(user.email)">
              <label><i class="fa fa-envelope-o"></i></label><span>{{user.email}}</span>
            </div>
            <div class="user-item" v-if="!$baize.isEmpty(user.qq)">
              <label><i class="fa fa-qq"></i></label><span>{{user.qq}}</span>
            </div>
            <div class="user-item" v-if="!$baize.isEmpty(user.wechat)">
              <label><i class="fa fa-wechat"></i></label><span>{{user.wechat}}</span>
            </div>
            <div class="user-item" v-if="!$baize.isEmpty(user.weibo)">
              <label><i class="fa fa-weibo"></i></label><span>{{user.weibo}}</span>
            </div>
            <hr style="margin: 5px 0px;"/>
            <el-button type="text" style="float:right;" size="mini" @click="logout">退出</el-button>
            <el-button class="global-text-btn-danger" type="text" style="float:left" size="mini" @click="show.changePwd = true">修改密码</el-button>
          </div>
            <div slot="reference" class="right-btn user-btn" :class="{'active': show.userPopover}">
              <!-- 遮罩 -->
              <template v-if="loading.user">
                <div class="_user_photo"><i style="color: lightgray;" class="fa fa-spinner fa-pulse fa-x fa-fw"></i></div>
              </template>
              <template v-else>
                <img class="_user_photo" :src="user.photo"></img>
              </template>
            </div>
          </el-popover>
        </div>
      </div>
    </header>

    <!-- ------------------- 主体内容区域 ------------------- -->

    <div ref="mainContent" class="main-content">
      <div ref="mainContentInner" class="main-content-inner global-auto-width">
        <router-view v-show="!($store.state.isMobile&&show.userCenter)"></router-view>
      </div>
      <el-dialog title="密码修改" :visible.sync="show.changePwd" v-loading="loading.changePwd" width="30%" :close-on-click-modal="false">
        <el-form :inline="true" ref="pwdForm" :model="pwdForm" class="demo-form-inline" label-width="80px" size="mini" :rules="pwdRules">
          <el-row>
            <el-col :span="24">
            <el-form-item label="原密码" prop="oldPwd">
              <el-input type="password" v-model="pwdForm.oldPwd" placeholder="原密码"></el-input>
            </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="密码" prop="newPwd">
                <el-input type="password" v-model="pwdForm.newPwd" placeholder="密码"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="确认密码" prop="confirmPwd">
                <el-input type="password" v-model="pwdForm.confirmPwd" placeholder="确认密码"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="clear: both;"></div>
        <span slot="footer" class="dialog-footer">
      <el-button @click="show.changePwd = false" size="small">取 消</el-button>
      <el-button type="danger" @click="changePwd" size="small">修 改</el-button>
     </span>
      </el-dialog>
      <!-- ------------------- 底部区域 ------------------- -->
      <footer class="footer" :style="{'border-top-color': '#545c64'}">
        <div class="global-auto-width">
          <span>{{systemYear}} © {{systemCompany}} @ {{systemProfile}}</span>
          <a class="go-top" @click="goTop" :style="{color: '#545c64'}"><i class="fa fa-arrow-circle-up"></i></a>
        </div>
      </footer>
    </div>

  </template>

</div>
</template>

<script>

export default {
  name: 'Frame',
  data () {
    return {
      // 遮罩
      loading: {user: false, changePwd: false},
      // 显示
      show: {userPopover: false, userCenter: false, changePwd: false},
      // 当前用户
      user: new this.$common.model.BaseUser({}, this),
      pwdForm: {
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      },
      // 校验规则
      pwdRules: {
        oldPwd: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        newPwd: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        confirmPwd: [
          { required: true, message: '该项必填', trigger: 'change' }
        ]
      },
      // 菜单
      menus: [],
      // 环境信息
      systemYear:"未知",
      systemName:"未知",
      systemCompany:"未知",
      systemProfile:"未知",
      /* ----------------↓ 本页为跨系统共通，仅此部分有区别 ↓---------------- */
      // 后台路径
      urls: {
        findCurrentUser: 'rest/systemAuth/currentUser',
        findProfile: 'rest/sysInfo/getProfile'
      }
    }
  },
  computed: {
  },
  mounted: function () {
    var vm = this;
    window.addEventListener("message", function (event){
      if(event.data.act=="refreshFrame"){
        var loginFrame = window.document.getElementById('loginFrame');
        if(loginFrame){
          window.document.body.removeChild(loginFrame)
        }
        vm.initData();
      } else if(event.data.act=="logoutSuccess"){
        var loginFrame = window.document.getElementById('loginFrame');
        if(loginFrame){
          window.document.body.removeChild(loginFrame)
        }
        vm.initData();
      }
      }, false);
    // 数据初始化
    vm.initData();
  },
  methods: {

    /*
     * 数据初始化
     */
    initData: function () {
      var vm = this;
      // 获取系统信息
      vm.findProfile()
      // 获取用户信息
      vm.findCurrentUser();
    },
    /*
     * 退出
     */
    logout: function () {
      var vm = this;
      vm.show.userPopover=false;
      var loginFrame = document.getElementById('loginFrame')
      if (loginFrame == null) {
        loginFrame = document.createElement('iframe')
        loginFrame.setAttribute('id', 'loginFrame')
        loginFrame.style.position = 'absolute';
        loginFrame.style.boxSizing = 'border-box';
        loginFrame.style.width = window.top.innerWidth+'px';
        loginFrame.style.height = window.top.innerHeight+'px';
        loginFrame.style.top = '0';
        loginFrame.style.left = '0';
        loginFrame.style.padding = '0';
        loginFrame.style.zIndex = '9999';
        document.body.appendChild(loginFrame)
        // 调用后台
        vm.$http({method: 'GET', url: "rest/sysInfo/getLogoutUrl"}).then(response => {
          loginFrame.src = response.bodyText;
        }, response => {
          // 提示
          vm.$notify({type: 'error', message: '获取登录地址失败', position: 'bottom-right'});
        });
      }
      window.loginFrame = loginFrame;
    },

    /*
     * 获取当前用户
     */
    findCurrentUser: function () {
      var vm = this;
      // 遮罩
      vm.loading.user = true;
      // 调用后台
      vm.$http({method: 'GET', url: vm.urls.findCurrentUser}).then(response => {
        // 数据填充
        vm.user = new vm.$common.model.BaseUser(response.body.user, vm)
        // 默认头像
        vm.user.photo = vm.user.photo || '/static/img/photo.png'
        // 存入STORE
        vm.$store.state.user = vm.user
        // 菜单
        vm.menus = response.body.menus
        // 遮罩
        vm.loading.user = false;
      }, response => {
        // 遮罩
        vm.loading.user = false;
        // 提示
        vm.$notify({type: 'error', message: '获取当前用户失败', position: 'bottom-right'});
        // 异常处理
        vm.$baize.handle(vm, response, vm.findCurrentUser);
      });
    },

    /*
     * 获取环境信息
     */
    findProfile: function () {
      var vm = this;
      // 调用后台
      vm.$http({method: 'GET', url: vm.urls.findProfile}).then(response => {
        vm.systemYear=response.body.systemYear;
        vm.systemName=response.body.systemName;
        vm.systemCompany=response.body.systemCompany;
        vm.systemProfile=response.body.systemProfile;
      }, response => {
        // 提示
        vm.$notify({type: 'error', message: '获取版本信息失败', position: 'bottom-right'});
        // 异常处理
        vm.$baize.handle(vm, response, vm.findProfile);
      });
    },
    changePwd: function () {
      var vm = this;
      // 校验
      vm.$refs['pwdForm'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['pwdForm'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.changePwd = true;
        // 请求后台
        vm.$http.post('rest/systemAuth/changePwd', vm.pwdForm).then(function (response) {
          // 关闭遮罩
          vm.loading.changePwd = false;
          // 关闭窗口
          vm.show.changePwd = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.changePwd = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      });
    },
    /*
     * 回到顶部
     */
    goTop: function () {
      window.scrollTo(0, 0)
    },

    /*
     * 打开帮助窗口
     */
    openHelpWindow: function () {
      var width = window.innerWidth * 0.9
      var height = window.innerHeight * 0.9
      var left = window.innerWidth * 0.05
      var top = window.innerHeight * 0.05
      //window.open('static/doc/UserDoc.htm', '用户手册', 'width=' + width + ',height=' + height + ',left=' + left + ',top=' + top + ',location=no,menubar=no')
    }
  }
}
</script>

<style>

/*-------------- 头部 ---------------*/

.frame .header {
  height: 60px;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  color: #fff;
  font-size: 15px;
  line-height: 40px;
  z-index: 999;
  transition: background-color 0.5s;
}

/* 隐藏头部 */
.frame.hide-header .header {
  display: none;
}

/* ---- 标题 ---- */
.frame .header .system-title {
  float: left;
  font-size: 18px;
  margin-top: 8px;
  margin-right: 10px;
  color: rgba(255,255,255,0.5);
  font-weight: bold;
}
.frame .header .system-title i {
  font-size: 20px;
}

/* ----↓ 导航菜单 ↓---- */

.frame .menu {
  float: left;
  height: 100%;
}

/* ----↑ 导航菜单 ↑---- */

/*----↓ 右侧按钮 ↓----*/

.frame .right-btn {
  float: left;
  text-align: center;
  cursor: pointer;
  padding: 0 10px;
  font-size: 15px;
  outline: none;
}
.frame:not(.is-mobile) .right-btn:HOVER {
  background-color: rgba(255, 255, 255, 1);
}
.frame:not(.is-mobile) .right-btn.active {
  background-color: rgba(255, 255, 255, 0.8);
}
.frame:not(.is-mobile) .right-btn:not(:hover):not(.active) {
  color: white !important;
}
.frame .right-btn:focus {
  outline: none;
}
/* 用户 */
.frame .right-btn ._user_photo {
  width: 36px;
  line-height: 36px;
  text-align: center;
  height: 36px;
  border-radius:100%;
  background-color:white;
  margin: 2px 1px;
  float: left;
}

/*----↑ 右侧按钮 ↑----*/

/*----↓ 弹窗 ↓----*/

.frame-popover.el-popover {
  margin-top: 0px !important;
  font-size: 12px;
  z-index: 10001 !important;
  border-radius: 0px 0px 4px 4px;
}
/* 用户 */
.frame .user-item, .frame-popover .user-item {
  height: 26px;
  line-height: 26px;
}
.frame .user-item label, .frame-popover .user-item label {
  color: gray;
}
.frame .user-item i, .frame-popover .user-item i {
  width: 20px;
}
.frame .user-item._name, .frame-popover .user-item._name {
  color: black;
}

/*----↑ 弹窗 ↑----*/

/*--------------主体---------------*/

.frame:not(.hide-header) .main-content {
  margin-top: 60px;
}

/* 用户中心 */
.frame .user-center-ctn {
  line-height: 32px;
  padding-top: 5px;
}

.frame .user-center-ctn .global-panel {
  margin-bottom: 5px;
}

/*--------------底部---------------*/

.frame .footer {
  margin-top:10px;
  height: 40px;
  line-height: 40px;
  z-index: 1001;
  color: gray;
  border-top: 1px solid gray;
  font-size: 12px;
  text-align: center;
}

.frame .footer .go-top {
  float: right;
  margin-right:10px;
  font-size: 18px;
  cursor: pointer;
}

.frame .footer .go-top:not(:hover) {
  color: gray !important;
}
</style>



// WEBPACK FOOTER //
// src/app/Frame.vue